import React, { Fragment, useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

const SelectStudentDropdown = (props) => {
    const { onChange, value, classN, req, id, disabled } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const getStudentsList = async () => {
        const res = await postMethod("/get-students-list");
        if (checkServerData(res)) {
            const list = [],
                users = res.data.list;
            users.forEach((e, i) => {
                list.push({
                    key: i,
                    value: e.user_id,
                    text: `${e.user_name} ${e.user_surname}`,
                    content: (
                        <>
                            <FontAwesomeIcon icon={e.user_stat_code === "ACTIVE" ? faCheckCircle : faLeaf} className={`me-2 ${e.user_stat_code === "ACTIVE" ? "text-success" : "text-warning"}`} />
                            {`${e.user_name} ${e.user_surname}`}
                            {e.user_instagram && (
                                <span className="ms-2 text-small d-inline-block">
                                    (<FontAwesomeIcon icon={faInstagram} className="me-1" />
                                    {e.user_instagram})
                                </span>
                            )}
                        </>
                    ),
                });
            });
            setList(list);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getStudentsList();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                <Form.Label>
                    {t(`users.student`)} {req && <span className="text-danger">*</span>}
                </Form.Label>
                <p className="text-small">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" /> – {t("users.userActive")}
                    <br />
                    <FontAwesomeIcon icon={faLeaf} className="text-warning me-2" /> – {t("users.userNew")}
                </p>
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <Dropdown
                        placeholder={t("chooseOrSearch")}
                        search
                        fluid
                        selection
                        options={list}
                        onChange={(e, data) => onChange(data.value)}
                        value={value}
                        id={id}
                        disabled={disabled}
                        noResultsMessage={t("noResultsFound")}
                    />
                )}
            </Form.Group>
        </Fragment>
    );
};

export default SelectStudentDropdown;
